import { Component, OnInit } from '@angular/core';
import { ProjectService } from '../services/project.service';
import { Subscription } from 'rxjs';
import { environment } from '../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.css']
})
export class WelcomeComponent implements OnInit {

  project: any;
  projectSubscription: Subscription;

  languages = [
    { lang: "en", label: "English" },
    { lang: "ceb", label: "Cebuano" },
    { lang: "zh", label: "Chinese (Simplified)" },
    { lang: "zh-Hant", label: "Chinese (Traditional)" },
    { lang: "fil", label: "Filipino" },
    { lang: "fr", label: "French" },
    { lang: "hmn", label: "Hmong" },
    { lang: "ja", label: "Japanese" },
    { lang: "kh", label: "Khmer" },
    { lang: "ko", label: "Korean" },
    { lang: "mo", label: "Mongolian" },
    { lang: "ru", label: "Russian" },
    { lang: "sp", label: "Spanish" },
    { lang: "va", label: "Vietnamese" },
    { lang: "so", label: "Somali" },
    { lang: "am", label: "Amharic" },
  ].filter(function(l) {
    return environment.langs.indexOf(l.lang) >= 0;
  });

  constructor(
    private projectService: ProjectService,
    private translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
  ) {

    // for observing changes to the current project
    this.projectSubscription = projectService.currentProject$.subscribe(project => {
      this.project = project;
    });
    
    this.translate.setDefaultLang("en");
    this.translate.use("en");
    translate.addLangs(environment.langs);
    translate.setDefaultLang("en");

    const browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/en|fr/) ? browserLang : "en");
  }

  ngOnInit() {

  }

  ngOnDestroy() {
    this.projectSubscription.unsubscribe();
  }

  /**
   * Event handler for when user taps the 'Submit a comment' button
   */
  handleSubmitACommentTap() {
    const newRoute = `${this.route.snapshot.paramMap.get('id')}/form`;
    this.router.navigateByUrl(newRoute);
  }

}



// WEBPACK FOOTER //
// ./src/app/welcome/welcome.component.ts